import { createRouter } from '@tanstack/react-router'

import { PageLoader } from '@/components/loader'
import { routeTree } from '@/routeTree.gen.ts'
import { useAccountManagementStore } from '@/store/accountManagement/accountManagement'
import { useOrganizationStore } from '@/store/organization/organization'
import { LoginRequestBody } from '@/types/auth'

import { queryClient } from './query-client'

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
  interface HistoryState {
    track_id?: string
    loginRequestBody?: LoginRequestBody
    email?: string
  }
}

export const router = createRouter({
  context: {
    queryClient,
    orgStore: useOrganizationStore,
    accountManagementStore: useAccountManagementStore,
  },
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultPendingComponent: PageLoader,
})
